import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '@/redux/common/baseQuery';

export interface CatalogueEntry {
  key: string;
  name?: string;
  description?: string;
  variables?: string[];
  settings?: Record<string, unknown>;
  layers?: Record<string, { editable?: boolean }>;
  effective_value: Record<string, unknown>;
  system_value: Record<string, unknown>;
  tenant_value: Record<string, unknown>;
}

interface ListResponse {
  success: boolean;
  message_code: number;
  data: CatalogueEntry[];
  total: number;
}

interface SingleResponse {
  success: boolean;
  message_code: number;
  data: CatalogueEntry;
}

interface UpdateResponse {
  success: boolean;
  message_code: number;
}

interface UpdateConfigArgs {
  key: string;
  value: Record<string, unknown>;
}

export const emailTemplatesApi = createApi({
  reducerPath: 'emailTemplatesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['EmailTemplate'],
  endpoints: (builder) => ({
    listEmailTemplates: builder.query<ListResponse, void>({
      query: () => '/api/v1/configurations/catalogue?prefix=email_template.',
      providesTags: ['EmailTemplate'],
    }),
    getEmailTemplate: builder.query<SingleResponse, string>({
      query: (key) => `/api/v1/configurations/${key}`,
      providesTags: (_r, _e, key) => [{ type: 'EmailTemplate', id: key }],
    }),
    updateEmailTemplate: builder.mutation<UpdateResponse, UpdateConfigArgs>({
      query: ({ key, value }) => ({
        url: `/api/v1/configurations/${key}`,
        method: 'PUT',
        body: { value },
      }),
      invalidatesTags: (_r, _e, { key }) => [
        { type: 'EmailTemplate', id: key },
        'EmailTemplate',
      ],
    }),
  }),
});

export const {
  useListEmailTemplatesQuery,
  useGetEmailTemplateQuery,
  useUpdateEmailTemplateMutation,
} = emailTemplatesApi;
